import { Box, Fade, Typography, useTheme } from "@mui/material";

type HeaderContributorProps = {
  title: string;
  subtitle: string;
  description: string;
  fontSizeMd: number;
  fontSizeXs: number;
};
export const HeaderContributor = ({
  title,
  subtitle,
  description,
  fontSizeMd,
  fontSizeXs,
}: HeaderContributorProps) => {
  const theme = useTheme();
  return (
    <Box
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      height={300}
      gap={5}
    >
      <Fade in timeout={1000}>
        <Box display="flex" position="relative" justifyContent="center">
          <Box
            sx={{
              background: `linear-gradient(50deg, ${theme.palette.secondary[900]} , ${theme.palette.secondary[300]} 70%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            <Typography
              sx={{
                fontSize: { md: 70, xs: 45 },
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: { md: fontSizeMd, xs: fontSizeXs },
                letterSpacing: 1,
                fontWeight: 800,
                textTransform: "uppercase",
                lineHeight: 0.8,
              }}
            >
              {subtitle}
            </Typography>
          </Box>
        </Box>
      </Fade>
      <Fade in timeout={2000}>
        <Box display="flex" marginInline={3} justifyContent="center">
          <Typography
            sx={{
              color: theme.palette.secondary[100],
              textAlign: "center",
              maxWidth: 1000,
              fontSize: { xs: 13, md: 14 },
              textWrap: "pretty",
            }}
          >
            {description}
          </Typography>
        </Box>
      </Fade>
    </Box>
  );
};
